




































import { Component, Watch } from 'vue-property-decorator';
import { PersonModule } from '@/store/Customers/PersonModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import Person from '@/models/Customers/People/Person';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'People', components: { Alert }, metaInfo: { title: 'People' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.people.fields.firstName'), sortable: false, width: '20%' },
        { text: this.$t('pageText.people.fields.lastName'), sortable: false, width: '20%' },
        { text: this.$t('pageText.people.fields.email'), sortable: false, width: '40%' },
        { text: this.$t('pageText.people.fields.updatedAt'), sortable: false, width: '20%' }
    ];
    peoplePage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.peoplePage = +page;
        }
    }

    async beforeMount() {
        await PersonModule.getPeople(this.peoplePage);
    }

    get people() {
        return PersonModule.people;
    }

    get totalPeoplePages() {
        return PersonModule.totalPeoplePages;
    }

    get search() {
        return PersonModule.peopleSearch;
    }

    set search(searchText: string) {
        PersonModule.updatePeopleSearch(searchText);
    }

    get loading() {
        return PersonModule.loading;
    }

    get pageSize() {
        return PersonModule.pageSize;
    }

    @Watch('peoplePage')
    async onPeoplePageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.peoplePage}` } });
        // Get new people
        await PersonModule.getPeople(this.peoplePage);
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Note that when the search changes it puts the user back to the first page, incase there are new people
        this.peoplePage = 1;
        await PersonModule.getPeople(1);
    }

    async navigateToPerson(person: Person) {
        this.$router.push({ name: PageNames.Person, params: { id: person.id }, query: { tab: "0" } });
    }

}
